import { Box, styled, StyleProps } from "@acko-tech/building-blocks.ui.common";

interface IStyleProps extends StyleProps {
  mStyles: any;
}

export const ImageWrapper = styled(Box) <IStyleProps>`
  display: flex;
  align-items: center;
  @media (max - width: 768px) {
    ${({ mStyles }: any) => mStyles}
  }
`;
